import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { FirestoreService } from '../../services/firestore.service';


@Component({
  selector: 'app-people-update-details',
  templateUrl: './people-update-details.component.html',
  styleUrls: ['./people-update-details.component.sass']
})
export class PeopleUpdateDetailsComponent implements OnInit {
  uid;
  updateProfileForm;
  user;
  showSpinner: boolean = false;
  coverPhoto: string = "./assets/img/cover-login.png";

  constructor(
    public db: FirestoreService,
    public auth: AuthenticationService,
    public fb: FormBuilder,
    public rout: Router,
  ) {
    this.updateProfileForm = this.fb.group({
      name: [''],
      nameLast: [''],
      phoneNumber: [''],
    });
  }

  ngOnInit(): void {
    this.auth.getPeopleSignInUid()
    .then( res=> {      
      this.uid = res.uid;      
    })
    .then( res=> {
      console.log('uid@peopledetails: '+this.uid)
      this.user = this.db.getPeopleDetails(this.uid)
    })
  }

  // CRUD
  updateProfile(formValues){
    this.db.updatePeopleDetails(formValues, this.uid)
    .then(res =>{
      this.routeToPeopleDetailsPage();
    })
  }

  routeToPeopleDetailsPage(){
    this.rout.navigate(['people/details'])
  }



}

